
export const MODEL_CHANGE = 'model-change';
export const FORM_STRUCTURE_CHANGE = 'form-structure-change';
export const SUBMIT = 'submit';

export interface ValueEditorsEventMap<T> {
    [MODEL_CHANGE]: T;
    [FORM_STRUCTURE_CHANGE]: void;
    [SUBMIT]: never;
}

export interface ModelInputChangeEvent<T> extends CustomEvent{
    detail: T
}

export function createModelInputChangeEvent<T>(modelValue: T): ModelInputChangeEvent<T>  {
    return new CustomEvent(MODEL_CHANGE, {detail: modelValue});
}

export type FormSubmitRequestEvent = CustomEvent<{submitter: HTMLElement}>;